import { ReactComponent as Info } from 'images/icons/info-circle-dutone.svg';
import clsx from 'clsx';
import { MouseEvent, ReactNode } from 'react';
import { ModernIcon } from './ui/Icon';

interface HintProps {
  hint: ReactNode;
  className?: string;
}

const preventEvent = (e: MouseEvent<SVGSVGElement>) => {
  e.stopPropagation();
  e.preventDefault();
};

export function Hint({ hint, className }: HintProps) {
  if (!hint) return null;
  return (
    <ModernIcon
      onClick={preventEvent}
      icon={Info}
      className={clsx('hint', className)}
      title={hint}
      style={{ color: 'var(--primary-color)' }}
    />
  );
}
